import React, { useCallback } from 'react';

import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

import { Upload } from 'src/sections/documents/upload/Upload';

// --------------------------------------------------------

type FileUploadWidgetProps = {
  multiple: boolean;
  acceptableFileFormats: string;
  maxFileSize: number; // 50 * 1024 * 1024 = 50MB
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  error?: boolean;
};

const FileUploadWidget: React.FC<FileUploadWidgetProps> = ({
  multiple,
  acceptableFileFormats,
  maxFileSize,
  setFiles,
  error = false,
}) => {
  const theme = useTheme();

  const handleDropMultiFile = useCallback(
    (acceptedFiles: File[]) => {
      setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
    },
    [setFiles]
  );

  return (
    <Box
      sx={{
        p: 3,
        outline: 'none',
        borderRadius: 1,
        overflow: 'hidden',
        bgcolor: error
          ? alpha(theme.palette.error.main, 0.08)
          : theme.palette.grey['500_8'] || alpha(theme.palette.grey[500], 0.08),
        border: `1px dashed ${error ? theme.palette.error.main : theme.palette.grey['500_24'] || alpha(theme.palette.grey[500], 0.2)}`,
      }}
    >
      <Upload
        multiple={multiple}
        onDrop={handleDropMultiFile}
        isWidget
        accept={acceptableFileFormats}
        maxSize={maxFileSize}
        sx={{ cursor: 'pointer' }}
      />
    </Box>
  );
};

export default FileUploadWidget;
